import React, { useState, useEffect, useContext } from 'react';
import Button from '@material-ui/core/Button';
import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ScoresNumber,
  ScoresNumberPhoneStack,
  ScoresNumberRow,
} from '../layout/WrapperDiv';
import { MeasuresContext } from '../../containers/MeasuresContext/MeasuresContextProvider';
import {
  observation,
  SET_SCORES,
} from '../../containers/MeasuresContext/utils/constants';

// todo theme color
const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    minWidth: 34,
    backgroundColor: (theme.palette as any).scores.color,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: (theme.palette as any).graph.graphColor,
      color: theme.palette.common.black,
    },
  },
  focused: {
    padding: 0,
    minWidth: 34,
    backgroundColor: (theme.palette as any).graph.graphColor,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: (theme.palette as any).graph.graphColor,
      color: theme.palette.common.black,
    },
  },
}));

type ScoresNumbersProps = {
  name: mumms.measureShortNames;
  scoresCategory: mumms.ScoresCategory;
};

const SCORES_ROW_0_5 = [0, 1, 2, 3, 4, 5] as const;
const SCORES_ROW_6_10 = [6, 7, 8, 9, 10] as const;

export const ScoresNumbers = React.memo(
  ({ name, scoresCategory }: ScoresNumbersProps) => {
    const { dispatch, methodSelected } = useContext(MeasuresContext);
    const isNarrowPhoneView = useMediaQuery('(max-width:600px)', {
      noSsr: true,
    });
    const isByObservationMethod = methodSelected === observation;
    const isDisabled =
      methodSelected === null ||
      (isByObservationMethod && scoresCategory[name] === 'subjective');

    const scores = [...Array(11).keys()];
    const classes = useStyles();
    const scoresClassState = scores.reduce((seed, curr) => {
      seed[curr] = classes.root;
      return seed;
    }, {} as any);
    const [classState, setClassState] = useState(scoresClassState);
    const onClick = (i: any) => {
      setClassState({ ...scoresClassState, [i]: classes.focused });
      dispatch({
        type: SET_SCORES,
        payload: { name, score: i },
      });
    };
    // reset color button
    useEffect(() => {
      setClassState(scoresClassState);
    }, [methodSelected]);

    const renderScoreButton = (i: number) => (
      <Button
        key={i}
        variant="contained"
        className={classState[i]}
        onClick={() => onClick(i)}
        disabled={isDisabled}
      >
        {i}
      </Button>
    );

    if (isNarrowPhoneView) {
      return (
        <ScoresNumberPhoneStack>
          <ScoresNumberRow>
            {SCORES_ROW_0_5.map((i) => renderScoreButton(i))}
          </ScoresNumberRow>
          <ScoresNumberRow>
            {SCORES_ROW_6_10.map((i) => renderScoreButton(i))}
          </ScoresNumberRow>
        </ScoresNumberPhoneStack>
      );
    }

    return (
      <ScoresNumber>{scores.map((i) => renderScoreButton(i))}</ScoresNumber>
    );
  },
);
